export default "__VITE_ASSET__wiAIuSl3__"